var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.list &&
    typeof _vm.list == "object" &&
    Object.values(this.$props.list).length > 2
    ? _c("div", { ref: "htmlBody", staticClass: "container fl-pdf" }, [
        _c(
          "div",
          { staticClass: "pdf__article" },
          [
            _c("corpIcon", { staticStyle: { "max-height": "52px" } }),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "pdf__article__text",
                staticStyle: { display: "inline-block", width: "80%" },
              },
              [
                _vm._v("Отчёт по результатам онлайн-проверки физического лица"),
                _c("br"),
                _vm._v(
                  " по открытым реестрам данных на " +
                    _vm._s(_vm.dateParser(_vm.dateCheck))
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "pdf__main-info" }, [
          _c(
            "div",
            { staticClass: "pdf__header", staticStyle: { width: "17%" } },
            [_vm._v("ИСХОДНЫЕ ДАННЫЕ")]
          ),
          _vm._v(" "),
          _c("hr", { staticStyle: { margin: "0 0 10px" } }),
          _vm._v(" "),
          _vm.name &&
          _vm.patronymic &&
          _vm.surname &&
          _vm.formRadio == "nameForm"
            ? _c("p", { staticClass: "pdf__main-info__text" }, [
                _vm._v("ФИО: "),
                _c(
                  "span",
                  {
                    staticClass: "pdf__main-info__text_bold",
                    staticStyle: { "margin-left": "83px" },
                  },
                  [_vm._v(_vm._s(_vm.list.id_fl.name[0]))]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.birthday && _vm.formRadio == "nameForm"
            ? _c("p", { staticClass: "pdf__main-info__text" }, [
                _vm._v("Дата рождения: "),
                _c(
                  "span",
                  {
                    staticClass: "pdf__main-info__text_bold",
                    staticStyle: { "margin-left": "0px" },
                  },
                  [_vm._v(_vm._s(_vm.dateParser(_vm.birthday)))]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.inn && _vm.formRadio == "innForm"
            ? _c("p", { staticClass: "pdf__main-info__text" }, [
                _vm._v("ИНН ФЛ: "),
                _c(
                  "span",
                  {
                    staticClass: "pdf__main-info__text_bold",
                    staticStyle: { "margin-left": "63px" },
                  },
                  [_vm._v(_vm._s(_vm.inn))]
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pdf__main-info" }, [
          _c(
            "div",
            { staticClass: "pdf__header", staticStyle: { width: "17%" } },
            [_vm._v("РЕЗУЛЬТАТ ПОИСКА")]
          ),
          _vm._v(" "),
          _c("hr", { staticStyle: { margin: "0 0 10px" } }),
          _vm._v(" "),
          _vm.list.id_fl && _vm.list.id_fl && _vm.list.id_fl.name
            ? _c(
                "div",
                _vm._l(_vm.list.id_fl.name, function (name, i) {
                  return _c(
                    "p",
                    { key: i + "name", staticClass: "pdf__main-info__text" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.list.id_fl.name.length > 1
                            ? "ФИО " + (i + 1)
                            : "ФИО"
                        ) + ": \n                "
                      ),
                      _vm.list.id_fl.name.length > 1
                        ? _c(
                            "span",
                            {
                              staticClass: "pdf__main-info__text_bold",
                              staticStyle: {
                                "margin-left": "73px",
                                "padding-top": "5px",
                              },
                            },
                            [_vm._v(_vm._s(name))]
                          )
                        : _c(
                            "span",
                            {
                              staticClass: "pdf__main-info__text_bold",
                              staticStyle: { "margin-left": "85px" },
                            },
                            [_vm._v(_vm._s(name))]
                          ),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.list.id_fl && _vm.list.id_fl && _vm.list.id_fl.birthday
            ? _c("p", { staticClass: "pdf__main-info__text" }, [
                _vm._v("Дата рождения: "),
                _c(
                  "span",
                  {
                    staticClass: "pdf__main-info__text_bold",
                    staticStyle: { "margin-left": "5px" },
                  },
                  [_vm._v(_vm._s(_vm.dateParser(_vm.list.id_fl.birthday)))]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.list.id_fl &&
          _vm.list.id_fl.inn_fl &&
          _vm.list.id_fl.inn_fl.length &&
          _vm.list.id_fl.inn_fl.length > 1
            ? _c(
                "div",
                { staticClass: "pdf__main-info__text" },
                [
                  _c(
                    "p",
                    {
                      staticStyle: {
                        margin: "2px 90px 2px 0",
                        display: "inline-block",
                      },
                    },
                    [_vm._v("ИНН:")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.list.id_fl.inn_fl, function (inn, ind) {
                    return _c(
                      "span",
                      { key: ind, staticClass: "pdf__main-info__text_bold" },
                      [
                        _vm._v(_vm._s(inn)),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              ind == _vm.list.id_fl.inn_fl.length - 1
                                ? ""
                                : ", "
                            )
                          ),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              )
            : _vm.list.id_fl &&
              _vm.list.id_fl.inn_fl &&
              _vm.list.id_fl.inn_fl.length &&
              _vm.list.id_fl.inn_fl.length == 1
            ? _c("div", { staticClass: "pdf__main-info__text" }, [
                _c(
                  "p",
                  {
                    staticStyle: {
                      margin: "2px 90px 2px 0",
                      display: "inline-block",
                    },
                  },
                  [_vm._v("ИНН:")]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "pdf__main-info__text_bold" }, [
                  _vm._v(_vm._s(_vm.list.id_fl.inn_fl[0])),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.list.id_fl &&
          _vm.list.id_fl &&
          _vm.list.id_fl.passports &&
          _vm.list.id_fl.passports.length &&
          _vm.list.id_fl.passports.length > 1
            ? _c(
                "div",
                { staticClass: "pdf__main-info__text" },
                [
                  _c(
                    "p",
                    {
                      staticStyle: {
                        margin: "2px 59px 2px 0",
                        display: "inline-block",
                      },
                    },
                    [_vm._v("Паспорт:")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.list.id_fl.passports, function (pass, ind) {
                    return _c(
                      "span",
                      { key: ind, staticClass: "pdf__main-info__text_bold" },
                      [
                        _vm._v(_vm._s(pass)),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              ind == _vm.list.id_fl.passports.length - 1
                                ? ""
                                : ", "
                            )
                          ),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              )
            : _vm.list.id_fl &&
              _vm.list.id_fl &&
              _vm.list.id_fl.passports &&
              _vm.list.id_fl.passports.length &&
              _vm.list.id_fl.passports.length == 1
            ? _c("div", { staticClass: "pdf__main-info__text" }, [
                _c(
                  "p",
                  {
                    staticStyle: {
                      margin: "2px 59px 2px 0",
                      display: "inline-block",
                    },
                  },
                  [_vm._v("Паспорт:")]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "pdf__main-info__text_bold" }, [
                  _vm._v(_vm._s(_vm.list.id_fl.passports[0])),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.list.id_fl &&
          _vm.list.id_fl &&
          _vm.list.id_fl.phones &&
          _vm.list.id_fl.phones.length &&
          _vm.list.id_fl.phones.length > 1
            ? _c(
                "div",
                { staticClass: "pdf__main-info__text" },
                [
                  _c(
                    "p",
                    {
                      staticStyle: {
                        margin: "5px 56px 5px 0",
                        display: "inline-block",
                      },
                    },
                    [_vm._v("Телефон:")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.list.id_fl.phones, function (tel, ind) {
                    return _c(
                      "span",
                      {
                        key: ind + "b",
                        staticClass: "pdf__main-info__text_bold",
                      },
                      [
                        _vm._v(_vm._s(tel)),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              ind == _vm.list.id_fl.phones.length - 1
                                ? ""
                                : ", "
                            )
                          ),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              )
            : _vm.list.id_fl &&
              _vm.list.id_fl &&
              _vm.list.id_fl.phones &&
              _vm.list.id_fl.phones.length &&
              _vm.list.id_fl.phones.length == 1
            ? _c("div", { staticClass: "pdf__main-info__text" }, [
                _c(
                  "p",
                  {
                    staticStyle: {
                      margin: "5px 56px 5px 0",
                      display: "inline-block",
                    },
                  },
                  [_vm._v("Телефон:")]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "pdf__main-info__text_bold" }, [
                  _vm._v(_vm._s(_vm.list.id_fl.phones[0])),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.list.id_fl &&
          _vm.list.id_fl &&
          _vm.list.id_fl.auto &&
          _vm.list.id_fl.auto.length &&
          _vm.list.id_fl.auto.length > 1
            ? _c(
                "div",
                { staticClass: "pdf__main-info__text" },
                [
                  _c("span", { staticStyle: { margin: "5px 0 5px 0" } }, [
                    _vm._v("Гос. номер авто:"),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.list.id_fl.auto, function (auto, ind) {
                    return _c(
                      "span",
                      {
                        key: ind + "a",
                        staticClass: "pdf__main-info__text_bold",
                        staticStyle: { "margin-left": "3px" },
                      },
                      [
                        _vm._v(_vm._s(auto)),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              ind == _vm.list.id_fl.auto.length - 1 ? "" : ", "
                            )
                          ),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              )
            : _vm.list.id_fl &&
              _vm.list.id_fl &&
              _vm.list.id_fl.auto &&
              _vm.list.id_fl.auto.length &&
              _vm.list.id_fl.auto.length == 1
            ? _c("div", { staticClass: "pdf__main-info__text" }, [
                _c("span", { staticStyle: { padding: "5px 0 5px 0" } }, [
                  _vm._v("Гос. номер авто:"),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "pdf__main-info__text_bold",
                    staticStyle: { "margin-left": "3px" },
                  },
                  [_vm._v(_vm._s(_vm.list.id_fl.auto[0]))]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.list.id_fl &&
          _vm.list.id_fl &&
          _vm.list.id_fl.addresses &&
          _vm.list.id_fl.addresses.length &&
          _vm.list.id_fl.addresses.length > 1
            ? _c("div", { staticClass: "pdf__main-info__text" }, [
                _c(
                  "p",
                  {
                    staticStyle: {
                      margin: "5px 0 5px 0",
                      display: "inline-block",
                      "vertical-align": "top",
                    },
                  },
                  [_vm._v("Адрес:")]
                ),
                _vm._v(" "),
                _vm.list.id_fl &&
                _vm.list.id_fl &&
                _vm.list.id_fl.addresses &&
                _vm.list.id_fl.addresses.length &&
                _vm.list.id_fl.addresses.length > 1
                  ? _c(
                      "ol",
                      {
                        staticStyle: {
                          "list-style": "decimal",
                          display: "inline-block",
                          "margin-top": "0",
                          "vertical-align": "top",
                          "padding-left": "101px",
                          "padding-top": "0",
                        },
                      },
                      _vm._l(_vm.list.id_fl.addresses, function (adr, ind) {
                        return _c(
                          "li",
                          {
                            key: ind + "c",
                            staticClass: "pdf__main-info__text_bold",
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(adr) +
                                "\n                "
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ])
            : _vm.list.id_fl &&
              _vm.list.id_fl &&
              _vm.list.id_fl.addresses &&
              _vm.list.id_fl.addresses.length &&
              _vm.list.id_fl.addresses.length == 1
            ? _c("div", { staticClass: "pdf__main-info__text" }, [
                _c("p", { staticStyle: { display: "inline-block" } }, [
                  _vm._v("Адрес:"),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "pdf__main-info__text_bold",
                    staticStyle: { "padding-left": "73px" },
                  },
                  [_vm._v(_vm._s(_vm.list.id_fl.addresses[0]))]
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pdf__short-version" }, [
          _c(
            "div",
            { staticClass: "pdf__header", staticStyle: { width: "27%" } },
            [_vm._v("РЕЗУЛЬТАТ ПРОВЕРКИ (краткий)")]
          ),
          _vm._v(" "),
          _c("hr", { staticStyle: { margin: "0 0 10px" } }),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "pdf__short-version__text",
              class: { grey: _vm.isPassportsError },
              attrs: { href: "#passport" },
            },
            [
              !_vm.isPassportsError &&
              _vm.list.passports &&
              _vm.list.passports.data &&
              _vm.passportsCheck(_vm.list.passports.data)
                ? _c("i", { staticClass: "fas fa-check" })
                : _c("i", {
                    staticClass: "fas fa-times",
                    class: { hidden: _vm.isPassportsError },
                  }),
              _vm._v("Проверка паспорта\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "pdf__short-version__text",
              class: { grey: _vm.isCheckInnError || _vm.checkInnCode == 2 },
              attrs: { href: "#inn" },
            },
            [
              !_vm.isCheckInnError && _vm.checkInnCode == 1
                ? _c("i", { staticClass: "fas fa-check" })
                : _c("i", {
                    staticClass: "fas fa-times",
                    class: {
                      hidden: _vm.isCheckInnError || _vm.checkInnCode == 2,
                    },
                  }),
              _vm._v("Проверка ИНН\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "pdf__short-version__text",
              class: { grey: _vm.isFedRozyskError },
              attrs: { href: "#fed" },
            },
            [
              !_vm.isFedRozyskError && !_vm.isFedRozyskData
                ? _c("i", { staticClass: "fas fa-check" })
                : _c("i", {
                    staticClass: "fas fa-times",
                    class: { hidden: _vm.isFedRozyskError },
                  }),
              _vm._v("Реестр федерального розыска МВД РФ\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "pdf__short-version__text",
              class: { grey: _vm.isTerroristsError },
              attrs: { href: "#terrorist" },
            },
            [
              !_vm.isTerroristsError && !_vm.isTerroristsData
                ? _c("i", { staticClass: "fas fa-check" })
                : _c("i", {
                    staticClass: "fas fa-times",
                    class: { hidden: _vm.isTerroristsError },
                  }),
              _vm._v("Реестр террористов/экстремистов\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "pdf__short-version__text",
              class: { grey: _vm.isFsinError },
              attrs: { href: "#fsin" },
            },
            [
              !_vm.isFsinError && !_vm.isFsinData
                ? _c("i", { staticClass: "fas fa-check" })
                : _c("i", {
                    staticClass: "fas fa-times",
                    class: { hidden: _vm.isFsinError },
                  }),
              _vm._v("Реестр розыска ФСИН\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "pdf__short-version__text",
              class: { grey: _vm.isCrimeError },
              attrs: { href: "#crime" },
            },
            [
              !_vm.isCrimeError && !_vm.isCrimeData
                ? _c("i", { staticClass: "fas fa-check" })
                : _c("i", {
                    staticClass: "fas fa-times",
                    class: { hidden: _vm.isCrimeError },
                  }),
              _vm._v("Привлечение к уголовной ответственности\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "pdf__short-version__text",
              class: { grey: _vm.isFsspFlRozyskYkError },
              attrs: { href: "#fssp_yk" },
            },
            [
              !_vm.isFsspFlRozyskYkError && !_vm.isFsspFlRozyskYkData
                ? _c("i", { staticClass: "fas fa-check" })
                : _c("i", {
                    staticClass: "fas fa-times",
                    class: { hidden: _vm.isFsspFlRozyskYkError },
                  }),
              _vm._v(
                "Реестр розыска ФССП (совершенные преступления)\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "pdf__short-version__text",
              class: { grey: _vm.isFsspFlRozyskIpError },
              attrs: { href: "#fssp_ip" },
            },
            [
              !_vm.isFsspFlRozyskIpError && !_vm.isFsspFlRozyskIpData
                ? _c("i", { staticClass: "fas fa-check" })
                : _c("i", {
                    staticClass: "fas fa-times",
                    class: { hidden: _vm.isFsspFlRozyskIpError },
                  }),
              _vm._v(
                "Реестр розыска ФССП (по исполнительным производствам)\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "pdf__short-version__text",
              class: { grey: _vm.isFsspFlIpError },
              attrs: { href: "#fssp" },
            },
            [
              !_vm.isFsspFlIpError && !_vm.isFsspFlIpData
                ? _c("i", { staticClass: "fas fa-check" })
                : _c("i", {
                    staticClass: "fas fa-times",
                    class: { hidden: _vm.isFsspFlIpError },
                  }),
              _vm._v("Банк данных исполнительных производств ФССП\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "pdf__short-version__text",
              class: { grey: _vm.isBankruptError },
              attrs: { href: "#bankrupt" },
            },
            [
              !_vm.isBankruptError && !_vm.isBankruptData
                ? _c("i", { staticClass: "fas fa-check" })
                : _c("i", {
                    staticClass: "fas fa-times",
                    class: { hidden: _vm.isBankruptError },
                  }),
              _vm._v("Реестр банкротств физических лиц\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "pdf__short-version__text",
              class: { grey: _vm.isDismissedPersonError },
              attrs: { href: "#fired" },
            },
            [
              !_vm.isDismissedPersonError && !_vm.isDismissedPersonData
                ? _c("i", { staticClass: "fas fa-check" })
                : _c("i", {
                    staticClass: "fas fa-times",
                    class: { hidden: _vm.isDismissedPersonError },
                  }),
              _vm._v(
                "Реестр лиц, уволенных в связи с утратой доверия\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "pdf__short-version__text",
              class: { grey: _vm.isNedoimkiError },
              attrs: { href: "#nedoimki" },
            },
            [
              !_vm.isNedoimkiError && !_vm.isNedoimkiData
                ? _c("i", { staticClass: "fas fa-check" })
                : _c("i", {
                    staticClass: "fas fa-times",
                    class: { hidden: _vm.isNedoimkiError },
                  }),
              _vm._v("Налоговая задолженность ФЛ\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "pdf__short-version__text",
              class: { grey: _vm.isPledgeError },
              attrs: { href: "#pledge" },
            },
            [
              !_vm.isPledgeError && !_vm.list.pledge.data
                ? _c("i", { staticClass: "fas fa-check" })
                : _c("i", {
                    staticClass: "fas fa-times",
                    class: { hidden: _vm.isPledgeError },
                  }),
              _vm._v("Реестр залогов движимого имущества\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "pdf__short-version__text",
              class: { grey: _vm.isDisqPersonError },
              attrs: { href: "#disq" },
            },
            [
              !_vm.isDisqPersonError && !_vm.isDisqPersonData
                ? _c("i", { staticClass: "fas fa-check" })
                : _c("i", {
                    staticClass: "fas fa-times",
                    class: { hidden: _vm.isDisqPersonError },
                  }),
              _vm._v("Реестр дисквалифицированных лиц ФНС РОССИИ\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "pdf__short-version__text",
              class: { grey: _vm.isRestrictOnPartUlErorr },
              attrs: { href: "#restrict" },
            },
            [
              !_vm.isRestrictOnPartUlErorr
                ? _c("i", { staticClass: "fas fa-check" })
                : _c("i", {
                    staticClass: "fas fa-times",
                    class: { hidden: _vm.isRestrictOnPartUlErorr },
                  }),
              _vm._v("Реестр ограничений участия в ЮЛ ФНС РОССИИ\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "pdf__short-version__text",
              class: { grey: _vm.isCheckIpError },
              attrs: { href: "#ip" },
            },
            [
              !_vm.isCheckIpError && _vm.isCheckIpData
                ? _c("i", { staticClass: "fas fa-plus" })
                : _c("i", {
                    staticClass: "fas fa-minus",
                    class: { hidden: _vm.isCheckIpError },
                  }),
              _vm._v("Наличие статуса ИП\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "pdf__short-version__text",
              class: { grey: _vm.isSelfEmployedError },
              attrs: { href: "#employed" },
            },
            [
              !_vm.isSelfEmployedError && _vm.isSelfEmployedData
                ? _c("i", { staticClass: "fas fa-plus" })
                : _c("i", {
                    staticClass: "fas fa-minus",
                    class: { hidden: _vm.isSelfEmployedError },
                  }),
              _vm._v("Наличие статуса самозанятого\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "pdf__short-version__text",
              class: { grey: _vm.isMassPersonError },
              attrs: { href: "#mass_upr" },
            },
            [
              !_vm.isMassPersonError && !_vm.isMassPersonUprData
                ? _c("i", { staticClass: "fas fa-check" })
                : _c("i", {
                    staticClass: "fas fa-times",
                    class: { hidden: _vm.isMassPersonError },
                  }),
              _vm._v("Реестр массовых руководителей\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "pdf__short-version__text",
              class: { grey: _vm.isMassPersonError },
              attrs: { href: "#mass_uchr" },
            },
            [
              !_vm.isMassPersonError && !_vm.isMassPersonUchrData
                ? _c("i", { staticClass: "fas fa-check" })
                : _c("i", {
                    staticClass: "fas fa-times",
                    class: { hidden: _vm.isMassPersonError },
                  }),
              _vm._v("Реестр массовых учредителей\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "pdf__short-version__text",
              class: { grey: _vm.isAffilError },
              attrs: { href: "#affil" },
            },
            [
              !_vm.isAffilError && _vm.isAffilData
                ? _c("i", { staticClass: "fas fa-plus" })
                : _c("i", {
                    staticClass: "fas fa-minus",
                    class: { hidden: _vm.isAffilError },
                  }),
              _vm._v("Аффилированные структуры\n        "),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pdf__long-version" }, [
          _c(
            "div",
            { staticClass: "pdf__header", staticStyle: { width: "36%" } },
            [_vm._v("РЕЗУЛЬТАТ ПРОВЕРКИ (детализированный)")]
          ),
          _vm._v(" "),
          !_vm.isPassportsError
            ? _c("div", [
                _vm.list.passports &&
                _vm.list.passports.data &&
                _vm.passportsCheck(_vm.list.passports.data)
                  ? _c("i", { staticClass: "fas fa-check" })
                  : _c("i", { staticClass: "fas fa-times" }),
                _vm._v(" "),
                _c(
                  "h3",
                  {
                    staticClass: "pdf__long-version__sub-header",
                    staticStyle: { "margin-top": "5px" },
                    attrs: { id: "passport" },
                  },
                  [_vm._v("ПРОВЕРКА ПАСПОРТА")]
                ),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "10px 0 5px" } }),
                _vm._v(" "),
                _vm.isPassportsData
                  ? _c("div", [
                      _c("p", [
                        _vm._v(
                          "По данным ГУВМ МВД на " +
                            _vm._s(_vm.dateParser(_vm.dateCheck)) +
                            " года: "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        _vm._l(_vm.list.passports.data, function (pass, ind) {
                          return _c(
                            "li",
                            {
                              key: ind,
                              staticClass: "pdf__long-version__text",
                            },
                            [
                              _vm._v(
                                "\n                        паспорт " +
                                  _vm._s(pass.serial) +
                                  " " +
                                  _vm._s(pass.number) +
                                  " "
                              ),
                              !pass.passports
                                ? _c("span", { staticClass: "green" }, [
                                    _vm._v("действителен"),
                                  ])
                                : _c("span", { staticClass: "red" }, [
                                    _vm._v("не действителен"),
                                  ]),
                            ]
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm.list.passports && _vm.list.passports.data
                  ? _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n                По данным ГУВМ МВД на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года паспорт " +
                          _vm._s(_vm.list.passports.data.serial) +
                          " " +
                          _vm._s(_vm.list.passports.data.number) +
                          " \n                "
                      ),
                      !_vm.list.passports.data.passports
                        ? _c("span", { staticClass: "green" }, [
                            _vm._v("действителен"),
                          ])
                        : _c("span", { staticClass: "red" }, [
                            _vm._v("не действителен"),
                          ]),
                      _vm._v(".\n            "),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isCheckInnError
            ? _c("div", { attrs: { id: "inn" } }, [
                _vm.checkInnCode == 1
                  ? _c("i", { staticClass: "fas fa-check" })
                  : _c("i", {
                      staticClass: "fas fa-times",
                      class: { hidden: _vm.checkInnCode === 2 },
                    }),
                _vm._v(" "),
                _c("h3", { staticClass: "pdf__long-version__sub-header" }, [
                  _vm._v("ПРОВЕРКА ИНН"),
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "10px 0 5px" } }),
                _vm._v(" "),
                _vm.checkInnCode == 1
                  ? _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n                По данным ФНС РОССИИ на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          " "
                      ),
                      _c("span", { staticClass: "green" }, [
                        _vm._v("зарегистрирован(а)"),
                      ]),
                      _vm._v(
                        " в качестве налогоплательщика с ИНН " +
                          _vm._s(_vm.list.check_inn.data.inn) +
                          ". Регион первичной регистрации налогоплательщика: " +
                          _vm._s(
                            _vm.getRegionByInn(_vm.list.check_inn.data.inn)
                          ) +
                          ".\n            "
                      ),
                    ])
                  : _vm.checkInnCode === 2
                  ? _c("p", { staticClass: "grey" }, [
                      _vm._v(
                        "\n                Проверка ИНН не осуществлялась\n            "
                      ),
                    ])
                  : _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n                По данным ФНС РОССИИ на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          " "
                      ),
                      _c("span", { staticClass: "red" }, [
                        _vm._v("не зарегистрирован(а)"),
                      ]),
                      _vm._v(" в качестве налогоплательщика.\n            "),
                    ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isFedRozyskError
            ? _c("div", { attrs: { id: "fed" } }, [
                !_vm.isFedRozyskData
                  ? _c("i", { staticClass: "fas fa-check" })
                  : _c("i", { staticClass: "fas fa-times" }),
                _vm._v(" "),
                _c("h3", { staticClass: "pdf__long-version__sub-header" }, [
                  _vm._v("РЕЕСТР ФЕДЕРАЛЬНОГО РОЗЫСКА МВД"),
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "10px 0 5px" } }),
                _vm._v(" "),
                _c("p", { staticClass: "pdf__long-version__text" }, [
                  _vm._v(
                    "\n                По данным МВД РФ на " +
                      _vm._s(_vm.dateParser(_vm.dateCheck)) +
                      " года " +
                      _vm._s(_vm.list.id_fl.name[0]) +
                      " "
                  ),
                  _vm.isFedRozyskData
                    ? _c("span", { staticClass: "red" }, [_vm._v("состоит")])
                    : _c("span", { staticClass: "green" }, [
                        _vm._v("не состоит"),
                      ]),
                  _vm._v(" в реестре федерального розыска.\n            "),
                ]),
                _vm._v(" "),
                _vm.isFedRozyskData
                  ? _c(
                      "div",
                      _vm._l(
                        _vm.list.fed_rozysk.data.find_obj,
                        function (r, i) {
                          return _c("div", { key: i }, [
                            _c("p", { staticStyle: { margin: "5px 0" } }, [
                              _c("img", {
                                staticStyle: { width: "100px" },
                                attrs: { src: r.url_img },
                              }),
                            ]),
                          ])
                        }
                      ),
                      0
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isTerroristsError
            ? _c("div", { attrs: { id: "terrorist" } }, [
                !_vm.isTerroristsData
                  ? _c("i", { staticClass: "fas fa-check" })
                  : _c("i", { staticClass: "fas fa-times" }),
                _vm._v(" "),
                _c("h3", { staticClass: "pdf__long-version__sub-header" }, [
                  _vm._v("РЕЕСТР ТЕРРОРИСТОВ/ЭКСТРЕМИСТОВ"),
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "10px 0 5px" } }),
                _vm._v(" "),
                !_vm.isTerroristsData
                  ? _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n                По данным Росфинмониторинг на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          " "
                      ),
                      _c("span", { staticClass: "green" }, [
                        _vm._v("не состоит"),
                      ]),
                      _vm._v(
                        " в реестре террористов/экстремистов.\n            "
                      ),
                    ])
                  : _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n                По данным Росфинмониторинг на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          _vm._s(
                            _vm.dateParser(
                              _vm.list.terrorists.data.terrorists[0].bday
                            )
                              ? ", " +
                                  _vm.dateParser(
                                    _vm.list.terrorists.data.terrorists[0].bday
                                  )
                              : ""
                          ) +
                          _vm._s(
                            _vm.list.terrorists.data.terrorists[0].address
                              ? ", " +
                                  _vm.list.terrorists.data.terrorists[0].address
                              : ""
                          ) +
                          " "
                      ),
                      _vm.isTerroristsData
                        ? _c("span", { staticClass: "red" }, [
                            _vm._v("состоит"),
                          ])
                        : _vm._e(),
                      _vm._v(
                        " в реестре террористов/экстремистов.\n            "
                      ),
                    ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isFsinError
            ? _c("div", { attrs: { id: "fsin" } }, [
                !_vm.isFsinData
                  ? _c("i", { staticClass: "fas fa-check" })
                  : _c("i", { staticClass: "fas fa-times" }),
                _vm._v(" "),
                _c("h3", { staticClass: "pdf__long-version__sub-header" }, [
                  _vm._v("РЕЕСТР РОЗЫСКА ФСИН"),
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "10px 0 5px" } }),
                _vm._v(" "),
                _c("p", { staticClass: "pdf__long-version__text" }, [
                  _vm._v(
                    "\n                По данным ФСИН  на " +
                      _vm._s(_vm.dateParser(_vm.dateCheck)) +
                      " года " +
                      _vm._s(_vm.list.id_fl.name[0]) +
                      " \n                "
                  ),
                  _vm.isFsinData
                    ? _c("span", { staticClass: "red" }, [_vm._v("состоит")])
                    : _c("span", { staticClass: "green" }, [
                        _vm._v("не состоит"),
                      ]),
                  _vm._v(" в реестре розыска ФСИН.\n            "),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isCrimeError
            ? _c("div", { attrs: { id: "crime" } }, [
                _vm.isCrimeData
                  ? _c("i", { staticClass: "fas fa-times" })
                  : _c("i", { staticClass: "fas fa-check" }),
                _vm._v(" "),
                _c("h3", { staticClass: "pdf__long-version__sub-header" }, [
                  _vm._v("Привлечение к уголовной ответственности"),
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "10px 0 5px" } }),
                _vm._v(" "),
                _c("p", { staticClass: "pdf__long-version__text" }, [
                  _vm._v(
                    "\n                По данным на " +
                      _vm._s(_vm.dateParser(_vm.dateCheck)) +
                      " года в отношении " +
                      _vm._s(_vm.firstCapitalLetter(_vm.list.id_fl.name[0])) +
                      " \n                "
                  ),
                  _vm.isCrimeData
                    ? _c("span", [
                        _c("span", { staticClass: "red" }, [_vm._v("ИМЕЮТСЯ")]),
                        _vm._v(
                          " данные о привлечении к уголовной ответственности."
                        ),
                      ])
                    : _c("span", [
                        _c("span", { staticClass: "green" }, [
                          _vm._v("НЕ ИМЕЕТСЯ"),
                        ]),
                        _vm._v(
                          " данных о привлечении к уголовной ответственности."
                        ),
                      ]),
                ]),
                _vm._v(" "),
                _vm.isCrimeData
                  ? _c("div", [
                      _vm.list.crime.data.nationality
                        ? _c("p", [
                            _c("b", [_vm._v("Национальность")]),
                            _vm._v(
                              " - " +
                                _vm._s(_vm.list.crime.data.nationality) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.list.crime.data.birth_address
                        ? _c("p", [
                            _c("b", [_vm._v("Адрес рождения")]),
                            _vm._v(
                              " - " +
                                _vm._s(_vm.list.crime.data.birth_address) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.list.crime.data.living_address
                        ? _c("p", [
                            _c("b", [_vm._v("Адреса проживания")]),
                            _vm._v(
                              " - " +
                                _vm._s(
                                  _vm.list.crime.data.living_address.join("")
                                ) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isCrimeData
                  ? _c(
                      "div",
                      _vm._l(_vm.list.crime.data.crime, function (e, i) {
                        return _c("div", { key: i }, [
                          e.type == 1
                            ? _c("div", [
                                e.article_desc
                                  ? _c("span", [_vm._v(_vm._s(e.article_desc))])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          e.type == 2
                            ? _c("div", [
                                e.article
                                  ? _c("span", [
                                      _c("b", [_vm._v("Статья")]),
                                      _vm._v(" " + _vm._s(e.article)),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                e.part
                                  ? _c("span", [_vm._v("ч. " + _vm._s(e.part))])
                                  : _vm._e(),
                                _vm._v(" "),
                                e.article_desc
                                  ? _c("span", [_vm._v(_vm._s(e.article_desc))])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          e.type == 3
                            ? _c("div", [
                                e.decisions && e.decisions.length
                                  ? _c(
                                      "div",
                                      _vm._l(e.decisions, function (e, i) {
                                        return _c("p", { key: i }, [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(e) +
                                              ";\n                            "
                                          ),
                                        ])
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          e.type == 4
                            ? _c("div", [
                                e.type
                                  ? _c("span", [
                                      _c("b", [_vm._v("Статья")]),
                                      _vm._v(" " + _vm._s(e.type)),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                e.part
                                  ? _c("span", [_vm._v("ч. " + _vm._s(e.part))])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          e.type == 5
                            ? _c("div", [
                                !e.article || !e.article_desc
                                  ? _c("div", [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(e.info) +
                                          "\n                        "
                                      ),
                                    ])
                                  : e.article || e.article_desc
                                  ? _c("div", [
                                      e.article
                                        ? _c("span", [
                                            _c("b", [_vm._v("Статья")]),
                                            _vm._v(" " + _vm._s(e.article)),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      e.article_desc
                                        ? _c("span", [
                                            _vm._v(_vm._s(e.article_desc)),
                                          ])
                                        : _vm._e(),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          e.type == 6
                            ? _c("div", [
                                e.article_desc
                                  ? _c("p", [
                                      _c("b", [_vm._v("Статья")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(e.article) +
                                          " ч." +
                                          _vm._s(e.part) +
                                          " - " +
                                          _vm._s(e.article_desc)
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                e.fabula && e.fabula.length
                                  ? _c(
                                      "div",
                                      [
                                        _c("b", [
                                          _vm._v("Дополнительная информация"),
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(e.fabula, function (e, i) {
                                          return _c("p", { key: i }, [
                                            _vm._v(_vm._s(e) + ";"),
                                          ])
                                        }),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          e.type == 7
                            ? _c("div", [
                                e.koap
                                  ? _c("span", [_vm._v(_vm._s(e.koap))])
                                  : _c("span", [_vm._v(_vm._s(e.raw_article))]),
                              ])
                            : _vm._e(),
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isFsspFlRozyskYkError
            ? _c("div", { attrs: { id: "fssp_yk" } }, [
                !_vm.isFsspFlRozyskYkData
                  ? _c("i", { staticClass: "fas fa-check" })
                  : _c("i", { staticClass: "fas fa-times" }),
                _vm._v(" "),
                _c("h3", { staticClass: "pdf__long-version__sub-header" }, [
                  _vm._v("РЕЕСТР РОЗЫСКА ФССП (совершенные преступления)"),
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "10px 0 5px" } }),
                _vm._v(" "),
                _c("p", { staticClass: "pdf__long-version__text" }, [
                  _vm._v(
                    "\n                По данным ФССП   на " +
                      _vm._s(_vm.dateParser(_vm.dateCheck)) +
                      " года " +
                      _vm._s(_vm.list.id_fl.name[0]) +
                      " \n                "
                  ),
                  _vm.isFsspFlRozyskYkData
                    ? _c("span", { staticClass: "red" }, [_vm._v("состоит")])
                    : _c("span", { staticClass: "green" }, [
                        _vm._v("не состоит"),
                      ]),
                  _vm._v(
                    " в реестре розыска по подозрению в совершении преступлений.\n            "
                  ),
                ]),
                _vm._v(" "),
                _vm.isFsspFlRozyskYkData
                  ? _c(
                      "div",
                      _vm._l(_vm.list.fssp_fl_rozysk_yk.data, function (y, i) {
                        return _c(
                          "div",
                          {
                            key: i,
                            staticStyle: {
                              "font-size": "12px",
                              margin: "10px 0",
                            },
                          },
                          [
                            _c("div", [
                              _c("b", [_vm._v("Адрес проживания:")]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(y.address))]),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("b", [_vm._v("Орган инициировавший розыск:")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(y.name_org_initiating)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("b", [_vm._v("Орган осуществляющий розыск:")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(y.name_org_initiates)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("b", [_vm._v("Статья:")]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(y.statya))]),
                            ]),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isFsspFlRozyskIpError
            ? _c("div", { attrs: { id: "fssp_ip" } }, [
                !_vm.isFsspFlRozyskIpData
                  ? _c("i", { staticClass: "fas fa-check" })
                  : _c("i", { staticClass: "fas fa-times" }),
                _vm._v(" "),
                _c("h3", { staticClass: "pdf__long-version__sub-header" }, [
                  _vm._v(
                    "РЕЕСТР РОЗЫСКА ФССП (по исполнительным производствам)"
                  ),
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "10px 0 5px" } }),
                _vm._v(" "),
                _c("p", { staticClass: "pdf__long-version__text" }, [
                  _vm._v(
                    "\n                По данным ФССП на " +
                      _vm._s(_vm.dateParser(_vm.dateCheck)) +
                      " года " +
                      _vm._s(_vm.list.id_fl.name[0]) +
                      " \n                "
                  ),
                  _vm.isFsspFlRozyskIpData
                    ? _c("span", { staticClass: "red" }, [_vm._v("состоит")])
                    : _c("span", { staticClass: "green" }, [
                        _vm._v("не состоит"),
                      ]),
                  _vm._v(
                    " в реестре розыска по подозрению в совершении преступлений.\n            "
                  ),
                ]),
                _vm._v(" "),
                _vm.isFsspFlRozyskIpData
                  ? _c(
                      "div",
                      _vm._l(
                        _vm.list.fssp_fl_rozysk_ip.data.result,
                        function (f, i) {
                          return _c(
                            "div",
                            {
                              key: i,
                              staticStyle: {
                                "font-size": "12px",
                                margin: "10px 0",
                              },
                            },
                            [
                              _c("div", [
                                f.ip_date
                                  ? _c("span", [_vm._v(_vm._s(f.ip_date))])
                                  : _vm._e(),
                                _vm._v(" "),
                                f.ip_number
                                  ? _c(
                                      "span",
                                      { staticStyle: { "font-size": "14px" } },
                                      [_vm._v(_vm._s(f.ip_number))]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              f.delo_number
                                ? _c("div", [
                                    _c("b", [_vm._v("Номер дела:")]),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(f.delo_number))]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              f.otdel_fssp
                                ? _c("div", [
                                    _c("b", [_vm._v("Адрес отдела:")]),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(f.otdel_fssp))]),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        }
                      ),
                      0
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isFsspFlIpError
            ? _c("div", { attrs: { id: "fssp" } }, [
                !_vm.isFsspFlIpData
                  ? _c("i", { staticClass: "fas fa-check" })
                  : _c("i", { staticClass: "fas fa-times" }),
                _vm._v(" "),
                _c("h3", { staticClass: "pdf__long-version__sub-header" }, [
                  _vm._v("БАНК ДАННЫХ ИСПОЛНИТЕЛЬНЫХ ПРОИЗВОДСТВ ФССП"),
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "10px 0 5px" } }),
                _vm._v(" "),
                _vm.isFsspFlIpData
                  ? _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n                По данным ФССП на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года в отношении " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          " "
                      ),
                      _c("span", { staticClass: "red" }, [_vm._v("имеются")]),
                      _vm._v(
                        " следующие возбужденные исполнительные производства:\n            "
                      ),
                    ])
                  : _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n                По данным ФССП на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года в отношении " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          " "
                      ),
                      _c("span", { staticClass: "green" }, [
                        _vm._v("отсутствуют "),
                      ]),
                      _vm._v(
                        " возбужденные исполнительные производства.\n            "
                      ),
                    ]),
                _vm._v(" "),
                _vm.isFsspFlIpData
                  ? _c(
                      "div",
                      [
                        _vm._l(
                          _vm.list.fssp_fl_ip.data.result,
                          function (z, i) {
                            return _c(
                              "div",
                              { key: i, staticClass: "pdf__long-version__box" },
                              [
                                z.ip_number && z.ip_date
                                  ? _c("p", [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "pdf__long-version__text_bold",
                                        },
                                        [
                                          _vm._v(
                                            "Исполнительное производство №"
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(z.ip_number) +
                                          " от " +
                                          _vm._s(z.ip_date)
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("p", [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "pdf__long-version__text_bold",
                                    },
                                    [_vm._v("Стадия исполнения:")]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        z.date_end ? "Окончено" : "Открыто"
                                      )
                                  ),
                                ]),
                                _vm._v(" "),
                                z.ip_info
                                  ? _c("p", [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "pdf__long-version__text_bold",
                                        },
                                        [_vm._v("Предмет исполнения:")]
                                      ),
                                      _vm._v(" " + _vm._s(z.ip_info)),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                z.info_doc
                                  ? _c("p", [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "pdf__long-version__text_bold",
                                        },
                                        [
                                          _vm._v(
                                            "Номер исполнительного документа:"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" " + _vm._s(z.info_doc)),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                z.summ
                                  ? _c("p", [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "pdf__long-version__text_bold",
                                        },
                                        [_vm._v("Сумма задолженности:")]
                                      ),
                                      _vm._v(" " + _vm._s(z.summ) + " руб"),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                z.otdel_fssp
                                  ? _c("p", [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "pdf__long-version__text_bold",
                                        },
                                        [
                                          _vm._v(
                                            "Адрес отдела судебных приставов:"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" " + _vm._s(z.otdel_fssp)),
                                    ])
                                  : _vm._e(),
                              ]
                            )
                          }
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "pdf__long-version__text_bold",
                            staticStyle: {
                              "font-size": "12px",
                              margin: "30px 0 0 15px",
                              "text-decoration": "underline",
                            },
                          },
                          [
                            _vm._v(
                              "Общее количество исполнительных производств: " +
                                _vm._s(_vm.list.fssp_fl_ip.data.result.length)
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "pdf__long-version__text_bold",
                            staticStyle: {
                              "font-size": "12px",
                              margin: "0 0 30px 15px",
                              "text-decoration": "underline",
                            },
                          },
                          [
                            _vm._v(
                              "Общая сумма задолженности: " +
                                _vm._s(
                                  _vm
                                    .getSum(
                                      _vm.list.fssp_fl_ip.data.result,
                                      "ip"
                                    )
                                    .toFixed(2)
                                ) +
                                " руб"
                            ),
                          ]
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isBankruptError
            ? _c("div", { attrs: { id: "bankrupt" } }, [
                !_vm.isBankruptData
                  ? _c("i", { staticClass: "fas fa-check" })
                  : _c("i", { staticClass: "fas fa-times" }),
                _vm._v(" "),
                _c("h3", { staticClass: "pdf__long-version__sub-header" }, [
                  _vm._v("РЕЕСТР БАНКРОТСТВ ФИЗИЧЕСКИХ ЛИЦ"),
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "10px 0 5px" } }),
                _vm._v(" "),
                !_vm.isBankruptError
                  ? _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n                По данным ЕФРСБ на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          " \n                "
                      ),
                      _vm.isBankruptData
                        ? _c("span", { staticClass: "red" }, [
                            _vm._v("состоит"),
                          ])
                        : _c("span", { staticClass: "green" }, [
                            _vm._v("не состоит"),
                          ]),
                      _vm._v(" в реестре банкротств.\n            "),
                    ])
                  : _vm.list.bankrupt.status == "not valid"
                  ? _c("p", [_vm._v(_vm._s(_vm.list.bankrupt.message))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isBankruptData
                  ? _c("div", [
                      _vm.list.bankrupt.data.type_text
                        ? _c("p", { staticClass: "pdf__long-version__text" }, [
                            _c(
                              "span",
                              { staticClass: "pdf__long-version__text_bold" },
                              [_vm._v("Стадия банкротства: ")]
                            ),
                            _vm._v(_vm._s(_vm.list.bankrupt.data.type_text)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.list.bankrupt.data.number_dela
                        ? _c("p", { staticClass: "pdf__long-version__text" }, [
                            _c(
                              "span",
                              { staticClass: "pdf__long-version__text_bold" },
                              [_vm._v("№ судебного дела: ")]
                            ),
                            _vm._v(_vm._s(_vm.list.bankrupt.data.number_dela)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.list.bankrupt.data.start_message_data &&
                      _vm.list.bankrupt.data.start_message_data.text
                        ? _c("p", { staticClass: "pdf__long-version__text" }, [
                            _c(
                              "span",
                              { staticClass: "pdf__long-version__text_bold" },
                              [_vm._v("Основание:")]
                            ),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.list.bankrupt.data.start_message_data.text
                                )
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isDismissedPersonError
            ? _c("div", { attrs: { id: "fired" } }, [
                !_vm.isDismissedPersonData
                  ? _c("i", { staticClass: "fas fa-check" })
                  : _c("i", { staticClass: "fas fa-times" }),
                _vm._v(" "),
                _c("h3", { staticClass: "pdf__long-version__sub-header" }, [
                  _vm._v("РЕЕСТР ЛИЦ, УВОЛЕННЫХ В СВЯЗИ С УТРАТОЙ ДОВЕРИЯ"),
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "10px 0 5px" } }),
                _vm._v(" "),
                _c("p", { staticClass: "pdf__long-version__text" }, [
                  _vm._v(
                    "\n                По данным системы государственной службы на " +
                      _vm._s(_vm.dateParser(_vm.dateCheck)) +
                      " года " +
                      _vm._s(_vm.list.id_fl.name[0]) +
                      " \n                "
                  ),
                  _vm.isDismissedPersonData
                    ? _c("span", { staticClass: "red" }, [_vm._v("состоит")])
                    : _c("span", { staticClass: "green" }, [
                        _vm._v("не состоит"),
                      ]),
                  _vm._v(
                    " в реестре лиц, уволенных в связи с утратой доверия.\n            "
                  ),
                ]),
                _vm._v(" "),
                _vm.isDismissedPersonData
                  ? _c(
                      "div",
                      [
                        _vm._l(
                          _vm.list.dismissed_person.data,
                          function (dis, i) {
                            return _c(
                              "div",
                              { key: i, staticClass: "pdf__long-version__box" },
                              [
                                dis.organization
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "pdf__long-version__text",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pdf__long-version__text_bold",
                                          },
                                          [
                                            _vm._v(
                                              "Наименование органа (организации):"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" " + _vm._s(dis.organization)),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                dis.position
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "pdf__long-version__text",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pdf__long-version__text_bold",
                                          },
                                          [_vm._v("Должность:")]
                                        ),
                                        _vm._v(" " + _vm._s(dis.position)),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                dis.violation
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "pdf__long-version__text",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pdf__long-version__text_bold",
                                          },
                                          [_vm._v("Основание увольнения: ")]
                                        ),
                                        _vm._v(" " + _vm._s(dis.violation)),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                dis.dismissal_date
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "pdf__long-version__text",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pdf__long-version__text_bold",
                                          },
                                          [_vm._v("Дата увольнения: ")]
                                        ),
                                        _vm._v(
                                          " " + _vm._s(dis.dismissal_date)
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "pdf__long-version__text_tip" },
                          [
                            _vm._v(
                              "*Поиск в реестре осуществляется по ФИО физического лица – возможны совпадения."
                            ),
                          ]
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isNedoimkiError
            ? _c("div", { attrs: { id: "nedoimki" } }, [
                !_vm.isNedoimkiData
                  ? _c("i", { staticClass: "fas fa-check" })
                  : _c("i", { staticClass: "fas fa-times" }),
                _vm._v(" "),
                _c("h3", { staticClass: "pdf__long-version__sub-header" }, [
                  _vm._v("НАЛОГОВАЯ ЗАДОЛЖЕННОСТЬ ФЛ"),
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "10px 0 5px" } }),
                _vm._v(" "),
                _vm.isNedoimkiData
                  ? _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n                По данным ФНС РОССИИ на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          " "
                      ),
                      _c("span", { staticClass: "red" }, [_vm._v("имеет")]),
                      _vm._v(
                        " следующие задолженности по уплате налогов:\n            "
                      ),
                    ])
                  : _vm.list.nedoimki.status == "not valid"
                  ? _c("p", [_vm._v(_vm._s(_vm.list.nedoimki.message))])
                  : _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n                По данным ФНС РОССИИ на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          " "
                      ),
                      _c("span", { staticClass: "green" }, [
                        _vm._v("не имеет "),
                      ]),
                      _vm._v(
                        " задолженностей по уплате налогов.\n            "
                      ),
                    ]),
                _vm._v(" "),
                _vm.isNedoimkiData
                  ? _c(
                      "div",
                      [
                        _vm._l(_vm.list.nedoimki.data, function (ned, i) {
                          return _c(
                            "div",
                            { key: i, staticClass: "pdf__long-version__box" },
                            [
                              ned.name
                                ? _c(
                                    "p",
                                    { staticClass: "pdf__long-version__text" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "pdf__long-version__text_bold",
                                        },
                                        [
                                          _vm._v(
                                            "Тип налоговой задолженности: "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" " + _vm._s(ned.name)),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              ned.sum
                                ? _c(
                                    "p",
                                    { staticClass: "pdf__long-version__text" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "pdf__long-version__text_bold",
                                        },
                                        [_vm._v("Сумма: ")]
                                      ),
                                      _vm._v(" " + _vm._s(ned.sum) + " руб"),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              ned.recipient_name
                                ? _c(
                                    "p",
                                    { staticClass: "pdf__long-version__text" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "pdf__long-version__text_bold",
                                        },
                                        [_vm._v("Получатель задолженности: ")]
                                      ),
                                      _vm._v(" " + _vm._s(ned.recipient_name)),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              ned.date_create
                                ? _c(
                                    "p",
                                    { staticClass: "pdf__long-version__text" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "pdf__long-version__text_bold",
                                        },
                                        [
                                          _vm._v(
                                            "Дата возникновения задолженности: "
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.dateParser(ned.date_create)
                                          )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "pdf__long-version__text_bold",
                            staticStyle: {
                              "font-size": "12px",
                              margin: "30px 0 0 15px",
                              "text-decoration": "underline",
                            },
                          },
                          [
                            _vm._v(
                              "Общее количество налоговых задолженностей: " +
                                _vm._s(_vm.list.nedoimki.data.length)
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "pdf__long-version__text_bold",
                            staticStyle: {
                              "font-size": "12px",
                              margin: "0 0 30px 15px",
                              "text-decoration": "underline",
                            },
                          },
                          [
                            _vm._v(
                              "Общая сумма налоговой задолженности: " +
                                _vm._s(
                                  _vm.getSum(_vm.list.nedoimki.data).toFixed(2)
                                ) +
                                " руб"
                            ),
                          ]
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isPledgeError
            ? _c("div", { attrs: { id: "pledge" } }, [
                !_vm.isPledgeData
                  ? _c("i", { staticClass: "fas fa-check" })
                  : _c("i", { staticClass: "fas fa-times" }),
                _vm._v(" "),
                _c("h3", { staticClass: "pdf__long-version__sub-header" }, [
                  _vm._v("РЕЕСТР ЗАЛОГОВ ДВИЖИМОГО ИМУЩЕСТВА"),
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "10px 0 5px" } }),
                _vm._v(" "),
                _vm.isPledgeData
                  ? _c(
                      "div",
                      [
                        _c("p", { staticClass: "pdf__long-version__text" }, [
                          _vm._v(
                            "\n                    По данным на " +
                              _vm._s(_vm.dateParser(_vm.dateCheck)) +
                              " года " +
                              _vm._s(_vm.list.id_fl.name[0]) +
                              " "
                          ),
                          _c("span", { staticClass: "red" }, [_vm._v("имеет")]),
                          _vm._v(
                            " следующие зарегистрированные залоги движимого имущества:\n                "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.isPledgeData
                          ? _vm._l(_vm.list.pledge.data, function (pl, i) {
                              return _c("div", { key: i }, [
                                pl.notification_number
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "pdf__long-version__text",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pdf__long-version__text_bold",
                                          },
                                          [_vm._v("Номер уведомления: ")]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              pl.notification_number
                                                ? pl.notification_number
                                                : "—"
                                            ) +
                                            "\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                pl.date_reg
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "pdf__long-version__text",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pdf__long-version__text_bold",
                                          },
                                          [_vm._v("Дата уведомления: ")]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              pl.date_reg
                                                ? _vm.dateParser(pl.date_reg)
                                                : "—"
                                            ) +
                                            "\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                pl.pledgees && pl.pledgees.length
                                  ? _c("div", [
                                      pl.pledgees.length == 1
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "pdf__long-version__text",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pdf__long-version__text_bold",
                                                },
                                                [_vm._v("Залогодержатель: ")]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    pl.pledgees[0].name
                                                      ? pl.pledgees[0].name
                                                      : "—"
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      pl.pledgees.length > 1
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "pdf__long-version__text",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pdf__long-version__text_bold",
                                                },
                                                [_vm._v("Залогодержатели: ")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      pl.pledgees.length > 1
                                        ? _c(
                                            "div",
                                            _vm._l(
                                              pl.pledgees,
                                              function (pled, i) {
                                                return _c("div", { key: i }, [
                                                  _c("span", [
                                                    _vm._v(_vm._s(pled.name)),
                                                  ]),
                                                ])
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                pl.notification_number
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "pdf__long-version__text",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pdf__long-version__text_bold",
                                          },
                                          [_vm._v("Номер договора: ")]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              pl.contract_number
                                                ? pl.contract_number
                                                : "—"
                                            ) +
                                            "\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                pl.date_reg
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "pdf__long-version__text",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pdf__long-version__text_bold",
                                          },
                                          [_vm._v("Дата договора: ")]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              pl.contract_date_start
                                                ? _vm.dateParser(
                                                    pl.contract_date_start
                                                  )
                                                : "—"
                                            ) +
                                            "\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                pl.date_reg
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "pdf__long-version__text",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pdf__long-version__text_bold",
                                          },
                                          [
                                            _vm._v(
                                              "Срок исполнения обязательств по договору: "
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              pl.contract_date_end
                                                ? _vm.dateParser(
                                                    pl.contract_date_end
                                                  )
                                                : "—"
                                            ) +
                                            "\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                pl.properties
                                  ? _c("div", [
                                      pl.properties.transport &&
                                      pl.properties.transport.length
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "pdf__long-version__text",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "pdf__long-version__text_bold",
                                                },
                                                [_vm._v("Транспорт: ")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      pl.properties.transport &&
                                      pl.properties.transport.length
                                        ? _c(
                                            "table",
                                            {
                                              staticClass:
                                                "pdf__long-version__table",
                                            },
                                            [
                                              _vm._m(0, true),
                                              _vm._v(" "),
                                              _vm._l(
                                                pl.properties.transport,
                                                function (tr, i) {
                                                  return _c("tr", { key: i }, [
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          tr.vin ? tr.vin : "—"
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          tr.desc
                                                            ? tr.desc
                                                            : "—"
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          tr.frameNum
                                                            ? tr.frameNum
                                                            : "—"
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          tr.carBodyNum
                                                            ? tr.carBodyNum
                                                            : "—"
                                                        )
                                                      ),
                                                    ]),
                                                  ])
                                                }
                                              ),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      pl.properties.other &&
                                      pl.properties.other.length
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "pdf__long-version__text",
                                            },
                                            [_vm._v("Иное имущество: ")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      pl.properties.other &&
                                      pl.properties.other.length
                                        ? _c(
                                            "table",
                                            {
                                              staticClass:
                                                "pdf__long-version__table",
                                            },
                                            [
                                              _vm._m(1, true),
                                              _vm._v(" "),
                                              _vm._l(
                                                pl.properties.other,
                                                function (oth, i) {
                                                  return _c("tr", { key: i }, [
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          oth.id ? oth.id : "—"
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          oth.description
                                                            ? oth.description
                                                            : "—"
                                                        )
                                                      ),
                                                    ]),
                                                  ])
                                                }
                                              ),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                i !== _vm.list.pledge.data.length - 1
                                  ? _c("hr", {
                                      staticStyle: { margin: "20px 0 15px 0" },
                                    })
                                  : _vm._e(),
                              ])
                            })
                          : _vm._e(),
                      ],
                      2
                    )
                  : _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n                По данным на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          " "
                      ),
                      _c("span", { staticClass: "green" }, [
                        _vm._v("не имеет"),
                      ]),
                      _vm._v(
                        " зарегистрированных залогов движимого имущества.\n            "
                      ),
                    ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isDisqPersonError
            ? _c("div", { attrs: { id: "disq" } }, [
                !_vm.isDisqPersonData
                  ? _c("i", { staticClass: "fas fa-check" })
                  : _c("i", { staticClass: "fas fa-times" }),
                _vm._v(" "),
                _c("h3", { staticClass: "pdf__long-version__sub-header" }, [
                  _vm._v("РЕЕСТР ДИСКВАЛИФИЦИРОВАННЫХ ЛИЦ ФНС РОССИИ"),
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "10px 0 5px" } }),
                _vm._v(" "),
                _vm.isDisqPersonData
                  ? _c(
                      "div",
                      _vm._l(_vm.list.disq_person.data, function (dis, i) {
                        return _c("div", { key: i }, [
                          _c("p", { staticClass: "pdf__long-version__text" }, [
                            _vm._v(
                              "\n                        По данным ФНС РОССИИ на " +
                                _vm._s(_vm.dateParser(_vm.dateCheck)) +
                                " года " +
                                _vm._s(_vm.list.id_fl.name[0]) +
                                _vm._s(
                                  dis.birth_date
                                    ? "(" + _vm.dateParser(dis.birth_date)
                                    : ""
                                ) +
                                "\n                        " +
                                _vm._s(
                                  dis.birth_place
                                    ? ", " + dis.birth_place + ")"
                                    : dis.birth_date
                                    ? ")"
                                    : ""
                                ) +
                                " "
                            ),
                            _c("span", { staticClass: "red" }, [
                              _vm._v("состоит"),
                            ]),
                            _vm._v(
                              "  в реестре дисквалифицированных лиц\n                        и дисквалифицирован(а) с " +
                                _vm._s(_vm.dateParser(dis.date_start)) +
                                " по " +
                                _vm._s(_vm.dateParser(dis.date_stop)) +
                                " по " +
                                _vm._s(dis.koap_code) +
                                "\n                    "
                            ),
                          ]),
                        ])
                      }),
                      0
                    )
                  : _vm.list.disq_person.status == "not valid"
                  ? _c("p", [_vm._v(_vm._s(_vm.list.disq_person.message))])
                  : _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n                По данным ФНС РОССИИ на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          " "
                      ),
                      _c("span", { staticClass: "green" }, [
                        _vm._v("не состоит"),
                      ]),
                      _vm._v(
                        " в реестре дисквалифицированных лиц.\n            "
                      ),
                    ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isRestrictOnPartUlErorr
            ? _c("div", { attrs: { id: "restrict" } }, [
                !_vm.isRestrictOnPartUlErorr && !_vm.isRestrictOnPartUlData
                  ? _c("i", { staticClass: "fas fa-check" })
                  : _c("i", { staticClass: "fas fa-times" }),
                _vm._v(" "),
                _c("h3", { staticClass: "pdf__long-version__sub-header" }, [
                  _vm._v("РЕЕСТР ОГРАНИЧЕНИЙ УЧАСТИЯ В ЮЛ ФНС РОССИИ"),
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "10px 0 5px" } }),
                _vm._v(" "),
                !_vm.isRestrictOnPartUlErorr
                  ? _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n                По данным ФНС РОССИИ на " +
                          _vm._s(
                            _vm.dateParser(_vm.RestrictOnPartULDateUpdate)
                          ) +
                          " года " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          " \n                "
                      ),
                      !_vm.isRestrictOnPartUlData
                        ? _c("span", { staticClass: "green" }, [
                            _vm._v("НЕ ИМЕЕТ"),
                          ])
                        : _c("span", { staticClass: "red" }, [_vm._v("ИМЕЕТ")]),
                      _vm._v(" ограничения участия в ЮЛ.\n            "),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isRestrictOnPartUlData
                  ? _c(
                      "div",
                      [
                        _c("p", { staticClass: "pdf__long-version__text" }, [
                          _vm._v(
                            '\n                    Имеются ограничения участия в ЮЛ согласно 129-ФЗ от 08.08.2001 (статья 23, пункт 1, подпункт "ф") в виде отказа в государственной регистрации \n                    если в регистрирующий орган представлены документы для включения сведений об учредителе (участнике) ЮЛ либо о лице, имеющем право без доверенности \n                    действовать от имени ЮЛ.\n                '
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.formattedList, function (rest, i) {
                          return _c(
                            "div",
                            {
                              key: i,
                              staticStyle: { "padding-bottom": "10px" },
                            },
                            [
                              _c(
                                "p",
                                { staticClass: "pdf__long-version__text" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "pdf__long-version__text_bold",
                                    },
                                    [_vm._v("Причастность лица к ЮЛ:")]
                                  ),
                                  _vm._v(" " + _vm._s(rest.implication) + " "),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href:
                                          _vm.window.location.origin +
                                          "/company/" +
                                          rest.ogrn_ul,
                                        target: "_blank",
                                      },
                                    },
                                    [_vm._v(_vm._s(rest.ul_name))]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "pdf__long-version__text" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "pdf__long-version__text_bold",
                                    },
                                    [_vm._v("Причина ограничения:")]
                                  ),
                                  _vm._v(" " + _vm._s(rest.restrict_reason)),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "pdf__long-version__text" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "pdf__long-version__text_bold",
                                    },
                                    [_vm._v("Срок действия ограничение:")]
                                  ),
                                  _vm._v(
                                    " с " +
                                      _vm._s(_vm.dateParser(rest.date_start)) +
                                      " по " +
                                      _vm._s(_vm.dateParser(rest.date_end))
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    )
                  : _vm.list.restrict_on_part_ul.status == "not valid"
                  ? _c("p", [
                      _vm._v(_vm._s(_vm.list.restrict_on_part_ul.message)),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isCheckIpError
            ? _c("div", { attrs: { id: "ip" } }, [
                _vm.isCheckIpData
                  ? _c("i", { staticClass: "fas fa-plus" })
                  : _c("i", { staticClass: "fas fa-minus" }),
                _vm._v(" "),
                _c("h3", { staticClass: "pdf__long-version__sub-header" }, [
                  _vm._v("НАЛИЧИЕ СТАТУСА ИП"),
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "10px 0 5px" } }),
                _vm._v(" "),
                _vm.isCheckIpData
                  ? _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n                По данным ФНС РОССИИ на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          " "
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "text-transform": "uppercase",
                            "font-weight": "600",
                          },
                        },
                        [_vm._v("зарегистрирован(а)")]
                      ),
                      _vm._v(
                        " в качестве индивидуального предпринимателя.\n            "
                      ),
                    ])
                  : _vm.list.check_ip.status == "not valid"
                  ? _c("p", [_vm._v(_vm._s(_vm.list.check_ip.message))])
                  : _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n                По данным ФНС РОССИИ на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          " "
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "text-transform": "uppercase",
                            "font-weight": "600",
                          },
                        },
                        [_vm._v("не зарегистрирован(а)")]
                      ),
                      _vm._v(
                        " в качестве индивидуального предпринимателя.\n            "
                      ),
                    ]),
                _vm._v(" "),
                _vm.isCheckIpData
                  ? _c(
                      "div",
                      _vm._l(_vm.list.check_ip.data, function (ip, i) {
                        return _c(
                          "div",
                          {
                            key: i,
                            staticClass: "pdf__long-version__box",
                            staticStyle: { "margin-bottom": "0px" },
                          },
                          [
                            ip.ogrn
                              ? _c(
                                  "p",
                                  { staticClass: "pdf__long-version__text" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pdf__long-version__text_bold",
                                      },
                                      [_vm._v("ОГРНИП: ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            _vm.window.location.origin +
                                            "/person/" +
                                            ip.ogrn,
                                          target: "_blank",
                                        },
                                      },
                                      [_vm._v(_vm._s(ip.ogrn))]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            ip.fns_status
                              ? _c(
                                  "p",
                                  { staticClass: "pdf__long-version__text" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pdf__long-version__text_bold",
                                      },
                                      [_vm._v("Статус ФНС: ")]
                                    ),
                                    _vm._v(" " + _vm._s(ip.fns_status)),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            ip.date_start
                              ? _c(
                                  "p",
                                  { staticClass: "pdf__long-version__text" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pdf__long-version__text_bold",
                                      },
                                      [_vm._v("Дата регистрации: ")]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.dateParser(ip.date_start))
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            ip.date_stop
                              ? _c(
                                  "p",
                                  { staticClass: "pdf__long-version__text" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pdf__long-version__text_bold",
                                      },
                                      [_vm._v("Дата ликвидации: ")]
                                    ),
                                    _vm._v(
                                      " " + _vm._s(_vm.dateParser(ip.date_stop))
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            ip.okved_title
                              ? _c(
                                  "p",
                                  { staticClass: "pdf__long-version__text" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pdf__long-version__text_bold",
                                      },
                                      [_vm._v("Основной вид деятельности: ")]
                                    ),
                                    _vm._v(" " + _vm._s(ip.okved_title)),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            ip.reg_org && ip.reg_org.name
                              ? _c(
                                  "p",
                                  { staticClass: "pdf__long-version__text" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pdf__long-version__text_bold",
                                      },
                                      [_vm._v("Регистрационный орган: ")]
                                    ),
                                    _vm._v(" " + _vm._s(ip.reg_org.name)),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            ip.pf
                              ? _c(
                                  "p",
                                  { staticClass: "pdf__long-version__text" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pdf__long-version__text_bold",
                                      },
                                      [
                                        _vm._v(
                                          "Регистрация в Пенсионном фонде: "
                                        ),
                                      ]
                                    ),
                                    _vm._v(
                                      " \n                        " +
                                        _vm._s(
                                          ip.pf.issuer ? ip.pf.issuer : ""
                                        ) +
                                        "\n                        " +
                                        _vm._s(
                                          ip.pf.date
                                            ? "(" + ip.pf.date + ")"
                                            : ""
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isSelfEmployedError
            ? _c("div", { attrs: { id: "employed" } }, [
                _vm.isSelfEmployedData
                  ? _c("i", { staticClass: "fas fa-plus" })
                  : _c("i", { staticClass: "fas fa-minus" }),
                _vm._v(" "),
                _c("h3", { staticClass: "pdf__long-version__sub-header" }, [
                  _vm._v("НАЛИЧИЕ СТАТУСА САМОЗАНЯТОГО"),
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "10px 0 5px" } }),
                _vm._v(" "),
                _vm.isSelfEmployedData
                  ? _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n                По данным ФНС РОССИИ на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          " "
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "text-transform": "uppercase",
                            "font-weight": "600",
                          },
                        },
                        [_vm._v("ЯВЛЯЕТСЯ")]
                      ),
                      _vm._v(
                        " плательщиком налога на профессиональный доход ("
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "text-transform": "uppercase",
                            "font-weight": "600",
                          },
                        },
                        [_vm._v("ИМЕЕТ")]
                      ),
                      _vm._v(" статус самозанятого)\n            "),
                    ])
                  : _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n               По данным ФНС РОССИИ на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          " "
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "text-transform": "uppercase",
                            "font-weight": "600",
                          },
                        },
                        [_vm._v(" НЕ ЯВЛЯЕТСЯ")]
                      ),
                      _vm._v(
                        " плательщиком налога на профессиональный доход ("
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "text-transform": "uppercase",
                            "font-weight": "600",
                          },
                        },
                        [_vm._v("НЕ ИМЕЕТ")]
                      ),
                      _vm._v(" статус самозанятого)\n            "),
                    ]),
                _vm._v(" "),
                _vm.isSelfEmployedData
                  ? _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "При работе ЮЛ с данным ФЛ не нужно удерживать НДФЛ и начислять на его вознаграждение страховые взносы. Чеки, сформированные самозанятым, ЮЛ может учитывать в своих расходах."
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isMassPersonError
            ? _c("div", { attrs: { id: "mass_upr" } }, [
                !_vm.isMassPersonUprData
                  ? _c("i", { staticClass: "fas fa-check" })
                  : _c("i", { staticClass: "fas fa-times" }),
                _vm._v(" "),
                _c("h3", { staticClass: "pdf__long-version__sub-header" }, [
                  _vm._v("РЕЕСТР МАССОВЫХ РУКОВОДИТЕЛЕЙ"),
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "10px 0 5px" } }),
                _vm._v(" "),
                _vm.isMassPersonUprData
                  ? _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n                По данным ФНС РОССИИ на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          " \n                "
                      ),
                      _c("span", { staticClass: "red" }, [_vm._v("состоит")]),
                      _vm._v(
                        " \n                в реестре массовых руководителей и является руководителем " +
                          _vm._s(_vm.list.mass_person.data.mass_upr.amount) +
                          " организаций.\n            "
                      ),
                    ])
                  : _vm.list.mass_person.status == "not.valid"
                  ? _c("p", [_vm._v(_vm._s(_vm.list.mass_person.message))])
                  : _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "По данным ФНС РОССИИ на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          "  "
                      ),
                      _c("span", { staticClass: "green" }, [
                        _vm._v(" не состоит"),
                      ]),
                      _vm._v(" в реестре массовых руководителей."),
                    ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isMassPersonError
            ? _c("div", { attrs: { id: "mass_uchr" } }, [
                !_vm.isMassPersonUchrData
                  ? _c("i", { staticClass: "fas fa-check" })
                  : _c("i", { staticClass: "fas fa-times" }),
                _vm._v(" "),
                _c("h3", { staticClass: "pdf__long-version__sub-header" }, [
                  _vm._v("РЕЕСТР МАССОВЫХ УЧРЕДИТЕЛЕЙ"),
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "10px 0 5px" } }),
                _vm._v(" "),
                _vm.isMassPersonUchrData
                  ? _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n                По данным ФНС РОССИИ на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          "  \n                "
                      ),
                      _c("span", { staticClass: "red" }, [_vm._v("состоит")]),
                      _vm._v(
                        " \n                в реестре массовых учредителей и является учредителем " +
                          _vm._s(_vm.list.mass_person.data.mass_uchr.amount) +
                          " организаций.\n            "
                      ),
                    ])
                  : _vm.list.mass_person.status == "not.valid"
                  ? _c("p", [_vm._v(_vm._s(_vm.list.mass_person.message))])
                  : _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "По данным ФНС РОССИИ на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          "  "
                      ),
                      _c("span", { staticClass: "green" }, [
                        _vm._v(" не состоит"),
                      ]),
                      _vm._v(" в реестре массовых учредителей."),
                    ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isAffilError
            ? _c("div", { attrs: { id: "affil" } }, [
                !_vm.isAffilError && _vm.isAffilData
                  ? _c("i", { staticClass: "fas fa-plus" })
                  : _c("i", { staticClass: "fas fa-minus" }),
                _vm._v(" "),
                _c("h3", { staticClass: "pdf__long-version__sub-header" }, [
                  _vm._v("АФФИЛИРОВАННЫЕ ОРГАНИЗАЦИИ"),
                ]),
                _vm._v(" "),
                _c("hr", { staticStyle: { margin: "10px 0 5px" } }),
                _vm._v(" "),
                _vm.isAffilData
                  ? _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n                По данным ФНС РОССИИ на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          " "
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "text-transform": "uppercase",
                            "font-weight": "600",
                          },
                        },
                        [_vm._v("имеет")]
                      ),
                      _vm._v(
                        " следующие аффилированные с ним(ней) организации:\n            "
                      ),
                    ])
                  : _vm.list.affil.status == "not valid"
                  ? _c("p", [_vm._v(_vm._s(_vm.list.affil.message))])
                  : _c("p", { staticClass: "pdf__long-version__text" }, [
                      _vm._v(
                        "\n                По данным ФНС РОССИИ на " +
                          _vm._s(_vm.dateParser(_vm.dateCheck)) +
                          " года " +
                          _vm._s(_vm.list.id_fl.name[0]) +
                          " "
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "text-transform": "uppercase",
                            "font-weight": "600",
                          },
                        },
                        [_vm._v("не имеет")]
                      ),
                      _vm._v(
                        " аффилированных с ним(ней) организаций.\n            "
                      ),
                    ]),
                _vm._v(" "),
                _vm.isAffilGraphicsData && _vm.list.affil.graphics.code === 0
                  ? _c(
                      "div",
                      [
                        _c(
                          "h3",
                          { staticClass: "pdf__long-version__sub-header" },
                          [_vm._v("Схема аффилированности")]
                        ),
                        _vm._v(" "),
                        _vm.list.affil &&
                        _vm.list.affil.graphics &&
                        _vm.list.affil.graphics.data &&
                        _vm.list.affil.graphics.data.nodes &&
                        _vm.list.affil.graphics.data.nodes.length
                          ? _c("flAfil", {
                              attrs: {
                                "fl-afil-data": _vm.list.affil.graphics.data,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isAffilTableData && _vm.list.affil.table.code === 0
                  ? _c("div", [
                      _c(
                        "h3",
                        { staticClass: "pdf__long-version__sub-header" },
                        [_vm._v("Аффилированность")]
                      ),
                      _vm._v(" "),
                      _vm.list.affil.table &&
                      _vm.list.affil.table.data.upr &&
                      _vm.list.affil.table.data.upr.length
                        ? _c("div", { staticClass: "pdf__long-version__box" }, [
                            _vm.list.affil.table.data.upr &&
                            _vm.list.affil.table.data.upr.length
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "pdf__long-version__table-description",
                                  },
                                  [
                                    _vm._v(
                                      "Является/являлся руководителем (совпадение по ИНН)"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.list.affil.table.data.upr &&
                            _vm.list.affil.table.data.upr.length
                              ? _c(
                                  "table",
                                  { staticClass: "pdf__long-version__table" },
                                  [
                                    _vm._m(2),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.list.affil.table.data.upr,
                                      function (up, i) {
                                        return _c("tbody", { key: i }, [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(up.inn ? up.inn : "—")
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            up.status_type[0] == 1 ||
                                            up.status_type[0] == 3
                                              ? _c("i", {
                                                  staticClass:
                                                    "fas fa-check-circle",
                                                })
                                              : up.status_type[0] == 0
                                              ? _c("i", {
                                                  staticClass:
                                                    "fas fa-times-circle",
                                                })
                                              : up.status_type[0] == 2
                                              ? _c("i", {
                                                  staticClass:
                                                    "fas fa-minus-circle",
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            up.ogrn
                                              ? _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        _vm.window.location
                                                          .origin +
                                                        "/company/" +
                                                        up.ogrn,
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        up.name_short
                                                          ? up.name_short
                                                          : up.name_full
                                                          ? up.name_full
                                                          : "—"
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      up.name_short
                                                        ? up.name_short
                                                        : up.name_full
                                                        ? up.name_full
                                                        : "—"
                                                    )
                                                  ),
                                                ]),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                up.stakeholder_type &&
                                                  up.stakeholder_type !==
                                                    "HISTORY" &&
                                                  !up.date_stop
                                                  ? "по н.в"
                                                  : "по " +
                                                      (up.stakeholder_date_end
                                                        ? _vm.dateParser(
                                                            up.stakeholder_date_end
                                                          )
                                                        : up.date_stop
                                                        ? _vm.dateParser(
                                                            new Date(
                                                              up.date_stop
                                                                .toString()
                                                                .slice(0, 4),
                                                              up.date_stop
                                                                .toString()
                                                                .slice(4, 6) -
                                                                1,
                                                              up.date_stop
                                                                .toString()
                                                                .slice(6)
                                                            )
                                                          )
                                                        : "-")
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                up.addr_full
                                                  ? up.addr_full
                                                  : "—"
                                              )
                                            ),
                                          ]),
                                        ])
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "pdf__long-version__text_bold" },
                              [
                                _vm._v(
                                  "Всего: " +
                                    _vm._s(_vm.list.affil.table.data.upr.length)
                                ),
                              ]
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "pdf__long-version__text_bold" },
                              [
                                _vm._v(
                                  "Действующие: " +
                                    _vm._s(
                                      _vm.list.affil.table.data.upr.filter(
                                        function (a) {
                                          return (
                                            a.status_type[0] == 1 ||
                                            a.status_type[0] == 3
                                          )
                                        }
                                      ).length
                                    )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "pdf__long-version__text_bold" },
                              [
                                _vm._v(
                                  "Ликвидированные: " +
                                    _vm._s(
                                      _vm.list.affil.table.data.upr.filter(
                                        function (a) {
                                          return a.status_type[0] == 0
                                        }
                                      ).length
                                    )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "pdf__long-version__text_bold" },
                              [
                                _vm._v(
                                  "Находятся в стадии ликвидации: " +
                                    _vm._s(
                                      _vm.list.affil.table.data.upr.filter(
                                        function (a) {
                                          return a.status_type[0] == 2
                                        }
                                      ).length
                                    )
                                ),
                              ]
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "pdf__long-version__text_bold" },
                              [
                                _c("b", [_vm._v("Действующий руководитель: ")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.currentStakeholder(
                                        _vm.list.affil.table.data.upr
                                      ).length
                                    )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "pdf__long-version__text_bold" },
                              [
                                _c("b", [_vm._v("Бывший руководитель: ")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.list.affil.table.data.upr.length -
                                        _vm.currentStakeholder(
                                          _vm.list.affil.table.data.upr
                                        ).length
                                    )
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.list.affil.table &&
                      _vm.list.affil.table.data.uchr &&
                      _vm.list.affil.table.data.uchr.length
                        ? _c("div", { staticClass: "pdf__long-version__box" }, [
                            _vm.list.affil.table.data.uchr &&
                            _vm.list.affil.table.data.uchr.length
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "pdf__long-version__table-description",
                                  },
                                  [
                                    _vm._v(
                                      "Является/являлся учредителем (совпадение по ИНН)"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.list.affil.table.data.uchr &&
                            _vm.list.affil.table.data.uchr.length
                              ? _c(
                                  "table",
                                  { staticClass: "pdf__long-version__table" },
                                  [
                                    _vm._m(3),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.list.affil.table.data.uchr,
                                      function (uch, i) {
                                        return _c("tbody", { key: i }, [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(uch.inn ? uch.inn : "—")
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            uch.status_type[0] == 1 ||
                                            uch.status_type[0] == 3
                                              ? _c("i", {
                                                  staticClass:
                                                    "fas fa-check-circle",
                                                })
                                              : uch.status_type[0] == 0
                                              ? _c("i", {
                                                  staticClass:
                                                    "fas fa-times-circle",
                                                })
                                              : uch.status_type[0] == 2
                                              ? _c("i", {
                                                  staticClass:
                                                    "fas fa-minus-circle",
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            uch.ogrn
                                              ? _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        _vm.window.location
                                                          .origin +
                                                        "/company/" +
                                                        uch.ogrn,
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        uch.name_short
                                                          ? uch.name_short
                                                          : uch.name_full
                                                          ? uch.name_full
                                                          : "—"
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      uch.name_short
                                                        ? uch.name_short
                                                        : uch.name_full
                                                        ? uch.name_full
                                                        : "—"
                                                    )
                                                  ),
                                                ]),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                uch.stakeholder_type &&
                                                  uch.stakeholder_type !==
                                                    "HISTORY" &&
                                                  !uch.date_stop
                                                  ? "по н.в"
                                                  : "по " +
                                                      (uch.stakeholder_date_end
                                                        ? _vm.dateParser(
                                                            uch.stakeholder_date_end
                                                          )
                                                        : uch.date_stop
                                                        ? _vm.dateParser(
                                                            new Date(
                                                              uch.date_stop
                                                                .toString()
                                                                .slice(0, 4),
                                                              uch.date_stop
                                                                .toString()
                                                                .slice(4, 6) -
                                                                1,
                                                              uch.date_stop
                                                                .toString()
                                                                .slice(6)
                                                            )
                                                          )
                                                        : "-")
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                uch.addr_full
                                                  ? uch.addr_full
                                                  : "—"
                                              )
                                            ),
                                          ]),
                                        ])
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "pdf__long-version__text_bold" },
                              [
                                _vm._v(
                                  "Всего: " +
                                    _vm._s(
                                      _vm.list.affil.table.data.uchr.length
                                    )
                                ),
                              ]
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "pdf__long-version__text_bold" },
                              [
                                _vm._v(
                                  "Действующие: " +
                                    _vm._s(
                                      _vm.list.affil.table.data.uchr.filter(
                                        function (a) {
                                          return (
                                            a.status_type[0] == 1 ||
                                            a.status_type[0] == 3
                                          )
                                        }
                                      ).length
                                    )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "pdf__long-version__text_bold" },
                              [
                                _vm._v(
                                  "Ликвидированные: " +
                                    _vm._s(
                                      _vm.list.affil.table.data.uchr.filter(
                                        function (a) {
                                          return a.status_type[0] == 0
                                        }
                                      ).length
                                    )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "pdf__long-version__text_bold" },
                              [
                                _vm._v(
                                  "Находятся в стадии ликвидации: " +
                                    _vm._s(
                                      _vm.list.affil.table.data.uchr.filter(
                                        function (a) {
                                          return a.status_type[0] == 2
                                        }
                                      ).length
                                    )
                                ),
                              ]
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "pdf__long-version__text_bold" },
                              [
                                _c("b", [_vm._v("Действующий учредитель: ")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.currentStakeholder(
                                        _vm.list.affil.table.data.uchr
                                      ).length
                                    )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "pdf__long-version__text_bold" },
                              [
                                _c("b", [_vm._v("Бывший учредитель: ")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.list.affil.table.data.uchr.length -
                                        _vm.currentStakeholder(
                                          _vm.list.affil.table.data.uchr
                                        ).length
                                    )
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isAffilFlHistoryData && _vm.list.affil.fl_history.code === 0
                  ? _c("div", [
                      _c(
                        "h3",
                        { staticClass: "pdf__long-version__sub-sub-header " },
                        [_vm._v("Исторические связи")]
                      ),
                      _vm._v(" "),
                      _vm.list.affil.fl_history &&
                      _vm.list.affil.fl_history.data &&
                      _vm.list.affil.fl_history.data.ul &&
                      _vm.list.affil.fl_history.data.ul.length
                        ? _c("div", { staticClass: "pdf__long-version__box" }, [
                            _vm.list.affil.fl_history.data &&
                            _vm.list.affil.fl_history.data.ul &&
                            _vm.list.affil.fl_history.data.ul.length
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "pdf__long-version__table-description",
                                  },
                                  [_vm._v("Исторические связи")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.list.affil.fl_history.data &&
                            _vm.list.affil.fl_history.data.ul &&
                            _vm.list.affil.fl_history.data.ul.length
                              ? _c(
                                  "table",
                                  { staticClass: "pdf__long-version__table" },
                                  [
                                    _vm._m(4),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.list.affil.fl_history.data.ul,
                                      function (his, i) {
                                        return _c("tbody", { key: i }, [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(his.inn ? his.inn : "—")
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            his.status == 1 || his.status == 3
                                              ? _c("i", {
                                                  staticClass:
                                                    "fas fa-check-circle",
                                                })
                                              : his.status == 0
                                              ? _c("i", {
                                                  staticClass:
                                                    "fas fa-times-circle",
                                                })
                                              : his.status == 2
                                              ? _c("i", {
                                                  staticClass:
                                                    "fas fa-minus-circle",
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            his.ogrn
                                              ? _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        _vm.window.location
                                                          .origin +
                                                        "/company/" +
                                                        his.ogrn,
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        his.name_short
                                                          ? his.name_short
                                                          : his.name_full
                                                          ? his.name_full
                                                          : "—"
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      his.name_short
                                                        ? his.name_short
                                                        : his.name_full
                                                        ? his.name_full
                                                        : "—"
                                                    )
                                                  ),
                                                ]),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(his.year ? his.year : "—")
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                his.address ? his.address : "—"
                                              )
                                            ),
                                          ]),
                                        ])
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "pdf__long-version__text_bold" },
                              [
                                _vm._v(
                                  "Всего: " +
                                    _vm._s(
                                      _vm.list.affil.fl_history.data.ul.length
                                    )
                                ),
                              ]
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "pdf__long-version__text_bold" },
                              [
                                _vm._v(
                                  "Действующие: " +
                                    _vm._s(
                                      _vm.list.affil.fl_history.data.ul.filter(
                                        function (a) {
                                          return a.status == 1 || a.status == 3
                                        }
                                      ).length
                                    )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "pdf__long-version__text_bold" },
                              [
                                _vm._v(
                                  "Ликвидированные: " +
                                    _vm._s(
                                      _vm.list.affil.fl_history.data.ul.filter(
                                        function (a) {
                                          return a.status == 0
                                        }
                                      ).length
                                    )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "pdf__long-version__text_bold" },
                              [
                                _vm._v(
                                  "Находятся в стадии ликвидации: " +
                                    _vm._s(
                                      _vm.list.affil.fl_history.data.ul.filter(
                                        function (a) {
                                          return a.status == 2
                                        }
                                      ).length
                                    )
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Номер имущества:")]),
      _vm._v(" "),
      _c("th", [_vm._v("Описание:")]),
      _vm._v(" "),
      _c("th", [_vm._v("Номер шасси (рамы):")]),
      _vm._v(" "),
      _c("th", [_vm._v("Номер кузова:")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Номер имущества:")]),
      _vm._v(" "),
      _c("th", [_vm._v("Описание:")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("th", [_vm._v("ИНН")]),
      _vm._v(" "),
      _c("th", [_vm._v("Наименование")]),
      _vm._v(" "),
      _c("th", [_vm._v("Период")]),
      _vm._v(" "),
      _c("th", [_vm._v("Адрес")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("th", [_vm._v("ИНН")]),
      _vm._v(" "),
      _c("th", [_vm._v("Наименование")]),
      _vm._v(" "),
      _c("th", [_vm._v("Период")]),
      _vm._v(" "),
      _c("th", [_vm._v("Адрес")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("th", [_vm._v("ИНН")]),
      _vm._v(" "),
      _c("th", [_vm._v("Наименование")]),
      _vm._v(" "),
      _c("th", [_vm._v("Период")]),
      _vm._v(" "),
      _c("th", [_vm._v("Адрес")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }